<template>
    <div class="login-page">
        <transition name="fade">
            <div v-if="!registerActive" class="wallpaper-login"></div>
        </transition>
        <div class="wallpaper-register"></div>

        <div class="container" dir="rtl">
            <div class="row">
                <div class="col-lg-6 col-md-6 col-sm-8 mx-auto login-container">
                    <div v-if="!registerActive" class="card login" v-bind:class="{ error: emptyFields }">
                        <h1>ورود</h1>
                        <form class="form-group" onsubmit="return false;">
                            <input v-model="usernameLogin" type="text" class="form-control" placeholder="نام کاربری"
                                autocomplete="off" required name="username">
                            <input v-model="passwordLogin" type="password" class="form-control" placeholder="Password"
                                autocomplete="off" name="password" required>
                            <input type="submit" class="btn btn-primary" @click="doLogin" value="ارسال">
                            <p>حساب کاربری ندارید؟ <a href="#"
                                    @click="registerActive = !registerActive, emptyFields = false">حساب ایجاد کنید</a>
                            </p>
                            <p><a href="#">رمز خود را فراموش کردید؟</a></p>
                        </form>
                    </div>

                    <div v-else class="card register" v-bind:class="{ error: emptyFields }">
                        <h1>ثبت نام</h1>
                        <form class="form-group">
                            <input v-model="usernameReg" type="text"
                                :class="!usernameValid ? 'form-control usernameFail' : 'form-control'" name="username"
                                autocomplete="off" placeholder="نام کاربری" required @focusout="checkUsername">
                            <input v-model="fullnameReg" type="text" class="form-control" placeholder="نام کامل"
                                autocomplete="off" required name="fullname">
                            <input v-model="phoneReg" type="tel" class="form-control" placeholder="تلفن" autocomplete="off"
                                required name="phone">
                            <input v-model="passwordReg" type="password" class="form-control" autocomplete="off"
                                placeholder="رمز عبور" required name="password">
                            <input v-model="confirmReg" type="password" class="form-control" autocomplete="off"
                                placeholder="تکرار رمز عبور" required name="confirm">
                            <input class="btn btn-primary" @click="doRegister" value="ایجاد">
                            <p>حساب کاربری دارید؟ <a href="#"
                                    @click="registerActive = !registerActive, emptyFields = false">از اینجا وارد شوید</a>
                            </p>
                        </form>
                    </div>
                </div>
            </div>

        </div>
    </div>
</template>

<script>
import axios from 'axios';
import { Apis } from '../constants';
import Cookies from "js-cookie";
// import { useRouter } from 'vue-router';

export default {
    data() {
        return {
            registerActive: false,
            usernameLogin: "",
            passwordLogin: "",

            usernameReg: "",
            usernameValid: false,
            fullnameReg: "",
            phoneReg: "",
            passwordReg: "",
            confirmReg: "",
            emptyFields: false
        }
    },
    methods: {
        doLogin() {
            if (this.usernameLogin === "" || this.passwordLogin === "") {
                this.emptyFields = true;
            } else {
                this.$loading.show();
                let form_data = new FormData();
                form_data.append('username', this.usernameLogin);
                form_data.append('password', this.passwordLogin);
                axios.post(Apis.login, form_data, {
                    withCredentials: true
                }).then(response => {
                    console.log("response", response.data);
                    if (response.data.result === "true") {
                        localStorage.setItem("userID", response.data.userId);
                        localStorage.setItem("session_id", response.data.session_id);
                        localStorage.setItem("username", this.usernameLogin);
                        Cookies.set("userID", response.data.userId);
                        Cookies.set("session_id", response.data.session_id);
                        this.$router.push({ name: 'home', params: { username: this.usernameLogin } });
                    }
                    else {
                        this.$notifications.notify(
                            {
                                message: `<span><b>Login failed</b>, wrong username or password.</span>`,
                                icon: 'nc-icon nc-notification-70',
                                horizontalAlign: 'right',
                                verticalAlign: 'top',
                                type: 'danger'
                            })
                    }
                    this.$loading.hide();
                }).catch(error => {
                    console.log("error: ", error);
                    this.$loading.hide();
                });
            }
        },

        checkAuth() {
            console.log("checking ...");
            axios.get(Apis.is_auth_valid, {
                withCredentials: true
            }).then(response => {
                console.log(response);
            }).catch(error => {
                console.log(error);
            });
        },

        doRegister() {
            if (this.usernameReg === "" || this.fullnameReg === "" || this.phoneReg === "" || this.passwordReg === "" || this.confirmReg === "") {
                this.emptyFields = true;
            } else {
                if (this.passwordReg != this.confirmReg) {
                    this.$notifications.notify(
                        {
                            message: `<span><b>خطا</b>, رمز عبور و تکرار آن مطابقت ندارد.</span>`,
                            icon: 'nc-icon nc-notification-70 ',
                            horizontalAlign: 'right',
                            verticalAlign: 'top',
                            type: 'danger'
                        })
                    return;
                }
                else {

                    this.$loading.show();
                    let form_data = new FormData();
                    form_data.append('username', this.usernameReg);
                    form_data.append('fullname', this.fullnameReg);
                    form_data.append('phone', this.phoneReg);
                    form_data.append('password', this.passwordReg);
                    form_data.append('confirm', this.confirmReg);
                    axios.post(Apis.register, form_data, {
                        withCredentials: true
                    }).then(response => {
                        console.log("response", response.data);
                        if (response.data.result === "true") {
                            localStorage.setItem("userID", response.data.userId);
                            localStorage.setItem("session_id", response.data.session_id);
                            localStorage.setItem("username", this.usernameReg);
                            Cookies.set("userID", response.data.userId);
                            Cookies.set("session_id", response.data.session_id);
                            this.$router.push({ name: 'home', params: { username: this.usernameReg } });
                        }
                        else {
                            this.$notifications.notify(
                                {
                                    message: `<span><b>Registration failed</b>, ${response.data.message}.</span>`,
                                    icon: 'nc-icon nc-notification-70',
                                    horizontalAlign: 'right',
                                    verticalAlign: 'top',
                                    type: 'danger'
                                })
                        }
                        this.$loading.hide();
                    }).catch(error => {
                        console.log("error: ", error);
                        this.$loading.hide();
                    });
                }
            }
        },

        async checkUsername() {
            if (this.usernameReg !== "") {
                await axios.get(Apis.is_username_valid + `username=${this.usernameReg}`)
                    .then(response => {
                        if (typeof response.data.result === "boolean")
                            this.usernameValid = response.data.result;
                        else {
                            this.usernameValid = response.data.result === "true" ? true : false;
                        }
                    })
                    .catch(error => {
                        console.log(error);
                    });
            }
        }
    }
}
</script>

<style scoped lang="scss">
p {
    line-height: 1rem;
}

.card {
    padding: 20px;
}

.form-group {
    input {
        margin-bottom: 20px;
    }
}

.login-page {
    align-items: center;
    display: flex;
    height: 100vh;
    text-align: start;

    .wallpaper-login {
        background-image: url("../../public/img/login_background.jpg");
        background-size: cover;
        height: 100%;
        position: absolute;
        width: 100%;
    }

    .fade-enter-active,
    .fade-leave-active {
        transition: opacity .5s;
    }

    .fade-enter,
    .fade-leave-to {
        opacity: 0;
    }

    .wallpaper-register {
        background: url('../../public/img/login_background.jpg');
        background-size: cover;
        height: 100%;
        position: absolute;
        width: 100%;
        z-index: -1;
    }

    h1 {
        margin-bottom: 1.5rem;
    }

    .login-container {
        min-width: 300px;
    }
}

.error {
    animation-name: errorShake;
    animation-duration: 0.3s;
}

.usernameFail {
    border-color: red;
}

@keyframes errorShake {
    0% {
        transform: translateX(-25px);
    }

    25% {
        transform: translateX(25px);
    }

    50% {
        transform: translateX(-25px);
    }

    75% {
        transform: translateX(25px);
    }

    100% {
        transform: translateX(0);
    }
}
</style>
